export default __webpack_public_path__ + "static/media/thumb.c8df57d9.png";